<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-align: center;">Sharon Ellery was born and raised in London and still resides there.<br/>
This is her second novel.</p><br/>
<p style="text-align: center;">Her first novel, <em>Siblings</em>, was published by Austin Macauley<br/>
Publishers in May, 2022.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?2153b5ab